import styled from "styled-components";
import { COLORS, responsive } from "../../../../styles/constants.style";

export const CreateClientProfileFormWrapper = styled.div`
  background-color: ${COLORS.cirrus_white};

  .main-container {
    width: 100%;
    padding-top: 0px;
    padding-bottom: 22.5px;

    ${responsive.MOBILE`
       padding-top: 0px;
       padding-bottom: 16px;
    `}
  }

  .MuiGrid2-root {
    padding-right: 8px;
    padding-left: 8px;

    ${responsive.MOBILE`
       padding-right: 0px;
       padding-left: 0px;
    `}
  }
  .MuiGrid2-container {
    padding-right: 0px;
    padding-left: 0px;
    ${responsive.MOBILE`
      padding: 0px 8px !important;
    `}
  }

  .separator {
    margin-top: 24px;
    width: 100%;
    border-bottom: 1px solid ${COLORS.primary_light_blue4};
    &.dashed {
      border-bottom-style: dashed;
    }
    ${responsive.MOBILE`
      margin-top: 16px;
    `}
  }

  .MuiInputBase-input {
    color: ${COLORS.cirrus_black};
    text-overflow: ellipsis;
  }

  .company-id-number {
    ${responsive.MOBILE`
      padding: 0 8px;
    `}
  }
`;
